import { Card } from '../../components/Shared/Card';

import './index.css';

function LoadingPage() {
  return (
    <div
      className='Background'
    >
      <div className='LoadingContainer'>
        <div className='LoadingCard'>
          <h3 className='LoadingHeader'>Loading...</h3>
        </div>
      </div>
    </div>
  )
}

export default LoadingPage;
